import styled from "styled-components";
import SensorsImage from "../img/sensors-1.png";
import Video1 from "../img/drw-demo/A_IMG_2408.mov";
import Video2 from "../img/drw-demo/B_IMG_2412.mov";
import { Section, AccentedText } from "../layout/style";
import LoopInteractionImage from "../img/figures/ensemble-layout.png";

const ColumnContainer = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    min-height: 100%;
    margin-top: 50px;
    margin-bottom: 50px;
`;

const VideoColumn = styled.div`
    position: sticky;
    top: 0px;
    flex: 0 1 40%;
    width: 40%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #000000;
`;

const VideoTopRow = styled.div`
    flex: 1 0 50%;
    height: 50%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;


`;

const VideoBottomRow = styled.div`
    flex: 1 0 50%;
    height: 50%;
    display: flex;
    align-items: center;
`;

const SensorImageContainer = styled.img`
    width: 100%;
`;

const ContentColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    & section {
        width: 100%;
    }

    & section p {
        width: 100%;
        font-size: 1.2rem;
        line-height: 2rem;
    }
`;

const VideoContainer = styled.video`
    // height: 100vh;
    width: auto;
    // border: 2px solid #ffffff;
`;

const LoopInteractionImageContainer = styled.div`
    justify-self: flex-end;
    width: 100%;
    height: 50%;
    background: #000000;
    text-align: center;
    vertical-align: middle;
    border-top: 2px solid #000000;

    & img {
        width: 100%;
    }

`;

const VideoSlide = () => {



    return <ColumnContainer>
        <VideoColumn>
            <VideoTopRow>
                <VideoContainer autoPlay={true} loop={true} muted={true} src={Video1} />
                <VideoContainer autoPlay={true} loop={true} muted={true} src={Video2} />
            </VideoTopRow>
            <VideoBottomRow>
                <SensorImageContainer src={SensorsImage} />
            </VideoBottomRow>
        </VideoColumn>
        <ContentColumn>
            <Section>
                <p>In its current iteration, the production begins with <strong>movement</strong>: a duet between two dancers. The dancers wear custom-fabricated gloves and insoles with embedded <strong>sensors</strong> that capture intensity and duration of pressure arising through their shared movement. The <strong>data</strong> generated from these sensors are translated in real time into a <strong>visualization</strong>, which is then <strong>interpreted and sonified</strong> by two musicians who iterate on different dimensions of musicality using material from Tchaikovsky’s 5th Symphony. The dancers continue the iterative loop by responding to the music; their movement is then captured by proxy through the wearables, thereby initiating a cyclical negotiation between movement and sound. The choreography examines the relationship between body and technology, interrogating the limits of kinesthetic resolution in what can be captured through the wearables. </p>

            </Section>
            <LoopInteractionImageContainer>
                <img src={LoopInteractionImage} />
            </LoopInteractionImageContainer>
        </ContentColumn>
    </ColumnContainer>;
}

export default VideoSlide;